module.exports = __webpack_public_path__ + "img/数据管理图标.5d1139bf.png";